var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.27 106.54C82.6902 106.54 106.54 82.6902 106.54 53.27C106.54 23.8498 82.6902 0 53.27 0C23.8498 0 0 23.8498 0 53.27C0 82.6902 23.8498 106.54 53.27 106.54Z",
    fill: "#716CDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.73 59.44C24.58 57.82 24.8 55.97 24.91 54.12C25.04 51.86 25.36 49.61 25.76 47.37C26.17 45.05 26.62 42.75 27.23 40.47C28 37.58 28.96 34.76 30.37 32.1C31.12 30.69 31.94 29.3 33.11 28.19C34.51 26.85 36.17 26.32 38.08 27.04C39.52 27.58 40.81 28.38 41.94 29.41C44.3 31.55 46.39 33.92 48.1 36.62C48.63 37.46 49.2 38.29 49.6 39.2C49.82 39.7 50.15 39.85 50.66 39.78C51.18 39.71 51.69 39.58 52.22 39.61C52.49 39.63 52.55 39.43 52.61 39.21C53.11 37.1 54.12 35.19 55.14 33.3C56.31 31.13 57.64 29.07 59.26 27.19C60.03 26.29 60.83 25.44 61.76 24.7C62.36 24.22 63.02 23.86 63.76 23.66C64.6 23.43 65.37 23.73 66.11 24.05C66.79 24.34 67.37 24.8 67.91 25.29C70.18 27.35 71.97 29.8 73.48 32.46C75.91 36.74 77.77 41.26 79.27 45.94C80.06 48.38 80.6 50.89 81.07 53.41C81.35 54.92 81.65 56.44 81.81 57.97C81.93 59.08 81.88 60.21 81.74 61.34C81.54 62.99 81.13 64.57 80.51 66.11C79.71 68.12 78.56 69.93 77.19 71.6C74.3 75.14 70.67 77.7 66.55 79.61C63.38 81.08 60.03 82.01 56.58 82.57C53.8 83.03 50.98 83.07 48.2 82.87C42.9 82.49 37.92 80.99 33.45 78.02C30.91 76.33 28.79 74.22 27.21 71.6C26.11 69.77 25.35 67.79 25.04 65.66C24.75 63.69 24.7 61.7 24.74 59.47L24.73 59.44Z",
    fill: "#82EDBB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 52.9993L-30 52.9993L-9.5 8.99927L33 52.9993Z",
    fill: "#FFFFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.54,
    height: 106.54,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.e9189c794f191799f705fb0daf63d9cb.svg";
export { ForwardRef as ReactComponent };